import { HOME_QUICK_LINKS } from '../../constants/endpoints';
import request from '../request';

export interface HomeQuickLink {
  key: string;
  label: string;
  icon: string;
  href: {
    learner: string;
    educator: string;
  };
}

export interface HomeQuickLinksResponse {
  quickLinks: HomeQuickLink[];
}

export const fetchHomeQuickLinks =
  async (): Promise<HomeQuickLinksResponse> => {
    const { data } = await request({
      method: 'get',
      url: HOME_QUICK_LINKS(),
    });
    return data as HomeQuickLinksResponse;
  };
